<template>
  <div>
    <b-table
      striped
      hover
      :items="historyDataList"
      :fields="fields"
      :busy="isLoadingComponent"
      show-empty
      responsive
    >
      <template #table-busy>
        <div class="text-center text-secondary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:cell(no)="{ index }">
        {{ (currentPageList - 1) * 10 + index + 1 }}
      </template>

      <template v-slot:cell(status)="{ item }">
        <b-badge
          pill
          variant="light-success"
          class="text-capitalize"
          v-if="item.status === 'success'"
        >
          {{ item.status.replaceAll("_", " ").toLowerCase() }}
        </b-badge>
        <b-badge
          pill
          variant="light-warning"
          class="text-capitalize"
          v-else-if="item.status === 'processing' || item.status === 'draft'"
        >
          {{ item.status.replaceAll("_", " ").toLowerCase() }}
        </b-badge>
        <b-badge pill variant="light-danger" class="text-capitalize" v-else>
          {{ item.status.replaceAll("_", " ").toLowerCase() }}
        </b-badge>
      </template>
    </b-table>

    <div
      v-if="resultData.itemsPerPage > 0"
      class="mt-3 d-flex justify-content-between align-items-center"
    >
      <small
        >Showing {{ (resultData.currentPage - 1) * 10 + 1 }} to
        {{ (resultData.currentPage - 1) * 10 + 1 * resultData.itemCount }} from
        {{ resultData.totalItems }}</small
      >
      <b-pagination
        class="justify-content-end"
        v-model="currentPageList"
        :total-rows="resultData.totalItems"
        :per-page="resultData.itemsPerPage"
        aria-controls="my-table"
        @change="getData"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  ValidationProvider,
  ValidationObserver,
  configure,
} from "vee-validate";
import Ripple from "vue-ripple-directive";
configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid",
    dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
    // ...
  },
});
import {
  BTable,
  BSpinner,
  BBadge,
  BImg,
  BDropdown,
  BPagination,
  BDropdownItem,
  BButton,
  VBModal,
} from "bootstrap-vue";
import _ from "lodash";
export default {
  components: {
    BTable,
    BSpinner,
    BBadge,
    BImg,
    BDropdown,
    BDropdownItem,
    BPagination,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    historyData: {
      type: "",
    },
    formPayload: {
      type: "",
    },
    validations: {
      type: "",
    },
    editId: {
      type: "",
    },
    result: {
      type: "",
    },
    isLoading: {
      type: Boolean,
    },
    currentPage: {
      type: Number,
    },
    getData: {
      type: Function,
    },
  },
  watch: {
    isLoading(value) {
      this.isLoadingComponent = value;
    },
    historyData(value) {
      this.historyDataList = value;
    },
    currentPage(value) {
      this.currentPageList = value;
    },
    result(value) {
      this.resultData = value;
    },
  },
  data() {
    return {
      moment,
      isLoadingComponent: true,
      currentPageList: 1,
      resultData: {},
      historyDataList: [],
      fields: [
        { key: "no" },
        { key: "user.name", label: "Name" },
        { key: "user.email", label: "Email" },
        { key: "credential.phone_number", label: "Phone Number" },
        { key: "credential.password", label: "Password" },
        { key: "credential.product_id", label: "Product ID" },
        { key: "status" },
      ],
    };
  },
  computed: {
    rows() {
      return this.historyDataList.length;
    },
  },
};
</script>

<style></style>
